import { keysToSnake } from '#/api/adapters/wireCase';

/**
 * 盤點 create／update 共用：每次 map **全部** lines（全量 overwrite）。
 * 禁止 dirty／omit-unchanged／old-value 省略。
 * 不送 stocktakeDate／location／systemQty／countedWarehouseId；無帳列不支援。
 * line qty 欄：`countedQty` → wire `counted_qty`。
 */
export function serializeStocktakeCreate(values) {
  return serializeStocktakeWrite(values, { includeUpdatedAt: false });
}

/**
 * 盤點 update：同 create 全量 lines，另含 top-level updatedAt。
 */
export function serializeStocktakeUpdate(values) {
  return serializeStocktakeWrite(values, { includeUpdatedAt: true });
}

function serializeStocktakeWrite(values, { includeUpdatedAt }) {
  const {
    stocktakeNo: _ignoredNo,
    id: _ignoredId,
    stocktakeDate: _ignoredDate,
    updatedAt,
    remark,
    lines,
  } = values ?? {};

  const payload = {
    remark: remark ?? null,
    lines: mapStocktakeLines(lines),
  };

  if (includeUpdatedAt) {
    payload.updatedAt = updatedAt;
  }

  return keysToSnake(payload);
}

function mapStocktakeLines(lines = []) {
  return (Array.isArray(lines) ? lines : []).map((line) => ({
    inventoryStockId: line?.inventoryStockId ?? line?.invStockId ?? null,
    stockNo: line?.stockNo ?? '',
    countedQty: resolveCountedQty(line),
    countedAt: line?.countedAt ?? null,
  }));
}

function resolveCountedQty(line) {
  const qty = line?.countedQty ?? line?.countedQuantity;
  if (qty != null && qty !== '') {
    return qty;
  }
  return 0;
}
